import React, { useContext } from "react";
import { GreenMachineContext } from "../GreenMachineContext";
import Button from "../../../../Button";

export default function GreenMachineErrorReportsButton() {
  const { jumpToStage, STAGE_NUMBERS } = useContext(GreenMachineContext);

  return (
    <Button
      onClick={() => {
        jumpToStage(STAGE_NUMBERS.errorReports);
      }}
    >
      Error Reports
    </Button>
  );
}
